import { Helmet } from 'react-helmet'
import './references.style.scss'
import { Trans, withTranslation } from 'react-i18next';
import { ButtonComponent, ContainerComponent, ImageSwiper, ReferenceModalComponent, SubtitleComponent, TitleComponent } from '../../components';
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Pagination, Thumbs } from "swiper";
import i18n from '../../i18n';
import { useLocation, useNavigate } from 'react-router';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

//@ts-ignore
import roof1ipk from '../../assets/images/references/roof1ipk.webp';
//@ts-ignore
import roof2ipk from '../../assets/images/references/roof2ipk.webp';
//@ts-ignore
import roof3ipk from '../../assets/images/references/roof3ipk.webp';
//@ts-ignore
import charger1ipk from '../../assets/images/references/charger1ipk.webp';
//@ts-ignore
import charger2ipk from '../../assets/images/references/charger2ipk.webp';
//@ts-ignore
import inverteripk from '../../assets/images/references/inverteripk.webp';

//@ts-ignore
import roof1crimmpi from '../../assets/images/references/roof1crimmpi.webp';
//@ts-ignore
import roof2crimmpi from '../../assets/images/references/roof2crimmpi.webp';
//@ts-ignore
import invertercrimmpi from '../../assets/images/references/invertercrimmpi.webp';

//@ts-ignore
import cp1matiki from '../../assets/images/references/cp1matiki.webp';
//@ts-ignore
import cp2matiki from '../../assets/images/references/cp2matiki.webp';

//@ts-ignore
import krov1k from '../../assets/images/references/krov1k.webp';
//@ts-ignore
import krov2k from '../../assets/images/references/krov2k.webp';

//@ts-ignore
import h1 from '../../assets/images/references/h1.webp';
//@ts-ignore
import h2 from '../../assets/images/references/h2.webp';
//@ts-ignore
import h3 from '../../assets/images/references/h3.webp';
//@ts-ignore
import h4 from '../../assets/images/references/h4.webp';

//@ts-ignore
import k1 from '../../assets/images/references/k1.webp';

//@ts-ignore
import kr1 from '../../assets/images/references/kr1.webp';
//@ts-ignore
import kr2 from '../../assets/images/references/kr2.webp';

//@ts-ignore
import krc1 from '../../assets/images/references/krc1.webp';

//@ts-ignore
import krc2 from '../../assets/images/references/krc2.webp';

//@ts-ignore
import prc1 from '../../assets/images/references/prc1.webp';
//@ts-ignore
import prc2 from '../../assets/images/references/prc2.webp';

//@ts-ignore
import blt1 from '../../assets/images/references/blt1.webp';

//@ts-ignore
import jel1 from '../../assets/images/references/jel1.webp';
//@ts-ignore
import jel2 from '../../assets/images/references/jel2.webp';
//@ts-ignore
import jel3 from '../../assets/images/references/jel3.webp';

//@ts-ignore
import p1 from '../../assets/images/references/p1.webp';

//@ts-ignore
import buzet1 from '../../assets/images/references/buzet1.webp';
//@ts-ignore
import buzet2 from '../../assets/images/references/buzet2.webp';
//@ts-ignore
import buzet3 from '../../assets/images/references/buzet3.webp';
//@ts-ignore
import buzet4 from '../../assets/images/references/buzet4.webp';

//@ts-ignore
import vrsar11 from '../../assets/images/references/vrsar11.webp';
//@ts-ignore
import vrsar12 from '../../assets/images/references/vrsar12.webp';
//@ts-ignore
import vrsar21 from '../../assets/images/references/vrsar21.webp';
//@ts-ignore
import vrsar22 from '../../assets/images/references/vrsar22.webp';

//@ts-ignore
import pula1 from '../../assets/images/references/pula1.webp';
//@ts-ignore
import pula2 from '../../assets/images/references/pula2.webp';
//@ts-ignore
import pula3 from '../../assets/images/references/pula3.webp';
//@ts-ignore
import pula4 from '../../assets/images/references/pula4.webp';
//@ts-ignore
import f34 from '../../assets/images/references/projekt1/3f4.webp';

//@ts-ignore
import a1 from '../../assets/images/references/projekt2/a1.webp';
//@ts-ignore
import a2 from '../../assets/images/references/projekt2/a2.webp';
//@ts-ignore
import a3 from '../../assets/images/references/projekt2/a3.webp';
//@ts-ignore
import a4 from '../../assets/images/references/projekt2/a4.webp';
//@ts-ignore
import a5 from '../../assets/images/references/projekt2/a5.webp';
//@ts-ignore
import a6 from '../../assets/images/references/projekt2/a6.webp';
//@ts-ignore
import a7 from '../../assets/images/references/projekt2/a7.webp';
//@ts-ignore
import a8 from '../../assets/images/references/projekt2/a8.webp';

//@ts-ignore
import m1 from '../../assets/images/references/m1.webp';
//@ts-ignore
import m3 from '../../assets/images/references/m3.webp';
//@ts-ignore
import m4 from '../../assets/images/references/m4.webp';

//@ts-ignore
import iml1 from '../../assets/images/references/iml1.webp';
//@ts-ignore
import iml2 from '../../assets/images/references/iml2.webp';
//@ts-ignore
import iml3 from '../../assets/images/references/iml3.webp';
//@ts-ignore
import iml4 from '../../assets/images/references/iml4.webp';

import { useEffect, useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';

//@ts-ignore
import checkIcon from '../../assets/icons/checkIcon.svg';
import { useVideoStore } from '../../store';


function References({ t }: { t: any }) {

    const [openModal, setOpenModal] = useState(false);
    let { state = { buzet: false } } = useLocation();
    const [referenceContent, setReferenceContent] = useState(<></>);
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);
    const navigate = useNavigate();
    const setCurrentVideo = useVideoStore((state) => state.setCurrentVideo);
    const videos = useVideoStore((state) => state.videos);
    const location = useLocation();

    const closeModal = () => {
        setOpenModal(false);

        // Remove the "modal=open" from the URL when modal is closed
        const params = new URLSearchParams(location.search);
        params.delete("modal");
        navigate({ search: params.toString() }, { replace: true });
    };

    useEffect(() => {
        // Check if URL contains "modal=open" and open modal
        const params = new URLSearchParams(location.search);
        if (params.get("modal") === "open") {
            setReferenceContent(
                <div className="swiperContainer">
                    <h3><SubtitleComponent medium white centered large>{t('references.buzet.title')}</SubtitleComponent></h3>
                    <ImageSwiper images={[buzet1, buzet2, buzet3, buzet4]} thumbs={true} />

                    <div className="projectDescription">
                        <div>{generateParagraphs(t('references.buzet.subtitle1'))}</div>
                    </div>
                </div>)
            setOpenModal(true)
        }
    }, [location.search]);


    // useEffect(() => {
    //     console.log(buzetState);
    //     if (buzetState) {
    //         setReferenceContent(
    //             <div className="swiperContainer">
    //                 <h3><SubtitleComponent medium white centered large>{t('references.buzet.title')}</SubtitleComponent></h3>
    //                 <ImageSwiper images={[buzet1, buzet2, buzet3, buzet4]} thumbs={true} />

    //                 <div className="projectDescription">
    //                     <div>{generateParagraphs(t('references.buzet.subtitle1'))}</div>
    //                 </div>
    //             </div>)
    //         setOpenModal(true)
    //         state = { buzet: false }
    //         setBuzetState(false)
    //     }



    // }, [buzetState])



    function generateParagraphs(text: string): JSX.Element[] {
        const paragraphs = text.split('<br>').filter(paragraph => paragraph.trim() !== '');
        return paragraphs.map((paragraph, index) => {
            const parts = paragraph.split(':');
            return (
                <SubtitleComponent key={index} max><span className='referenceSpan'>{parts[0]}:</span>
                    {parts[1]}</SubtitleComponent>
            );
        });
    }

    return (
        <div className="references">
            <ReferenceModalComponent openModal={openModal} closeModal={() => { setOpenModal(false); closeModal() }} referenceContent={referenceContent} />
            <Helmet>
                <title>{t('references.meta.title')}</title>
                <meta name="description" content={t('references.meta.description')} />
            </Helmet>
            <ContainerComponent>
                <Trans>
                    <h1><TitleComponent centered smaller>{t('references.title')}</TitleComponent></h1>
                    <div className="referenceIntroText">
                        <SubtitleComponent max>{t('references.subtitle')} <span><a style={{ margin: 0 }} href='mailto:info@tesenergy.hr'>info@tesenergy.hr</a></span>.</SubtitleComponent>
                        <SubtitleComponent max>
                            <Trans i18nKey={'references.youtube'}>
                                {t('references.youtube')}<a target="_blank" rel="noopener noreferrer" href='https://www.youtube.com/@TESEnergy' >Youtube</a>
                            </Trans>
                        </SubtitleComponent>
                    </div>


                    <div className="swiperContainer">
                        <h3 onClick={() => navigate("/" + i18n.language + t('navbar.routes.project1') + "/")}><SubtitleComponent white semiBold centered medium>{t('project1.title')}</SubtitleComponent></h3>
                        <ImageSwiper images={[pula1, pula2, f34, pula4]} thumbs={true} />
                        <ButtonComponent green onClick={() => navigate("/" + i18n.language + t('navbar.routes.project1') + "/")}>{t('misc.learnMore')}</ButtonComponent>
                    </div>


                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.iml.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[iml1, iml2, iml3, iml4]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.iml.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.iml.title')}</SubtitleComponent></h3>
                            <img src={iml1} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.crimpi.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[roof1crimmpi, roof2crimmpi, invertercrimmpi]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.crimpi.subtitle1'))}</div>
                                        {/* <SubtitleComponent max>{t('references.crimpi.subtitle2')}</SubtitleComponent> */}
                                    </div>
                                </div>);
                            setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.crimpi.title')}</SubtitleComponent></h3>
                            <img src={roof1crimmpi} />
                        </div>
                    </div>

                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.ipk.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[roof1ipk, roof2ipk, roof3ipk, charger1ipk, charger2ipk, inverteripk]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.ipk.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.ipk.title')}</SubtitleComponent></h3>
                            <img src={roof1ipk} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.buzet.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[buzet1, buzet2, buzet3, buzet4]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.buzet.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.buzet.title')}</SubtitleComponent></h3>
                            <img src={buzet1} />
                        </div>

                    </div>

                    <div className="swiperContainer">
                        <h3 onClick={() => navigate("/" + i18n.language + t('navbar.routes.project2') + "/")}><SubtitleComponent white semiBold centered medium>{t('project2.title')}</SubtitleComponent></h3>
                        <ImageSwiper images={[a1, a4, a5, a8]} thumbs={true} />
                        <ButtonComponent green onClick={() => navigate("/" + i18n.language + t('navbar.routes.project2') + "/")}>{t('misc.learnMore')}</ButtonComponent>
                    </div>

                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.mirtex.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[m1, m3, m4]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.mirtex.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.mirtex.title')}</SubtitleComponent></h3>
                            <img src={m1} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.matiki.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[cp2matiki, cp1matiki]} thumbs={true} />
                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.matiki.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.matiki.title')}</SubtitleComponent></h3>
                            <img src={cp2matiki} />
                        </div>
                    </div>
                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.pucic.title')}</SubtitleComponent></h3>
                                    <Swiper navigation={true} modules={[Navigation, Pagination]} pagination={{ type: "progressbar" }} className="mySwiper">
                                        <SwiperSlide><img src={p1} /></SwiperSlide>
                                    </Swiper>
                                    <Swiper
                                        onSwiper={setThumbsSwiper}
                                        spaceBetween={10}
                                        slidesPerView={4}
                                        freeMode={true}
                                        watchSlidesProgress={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper"
                                    >
                                        <SwiperSlide><img src={p1} /></SwiperSlide>

                                    </Swiper>
                                    <ImageSwiper images={[p1]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.pucic.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.pucic.title')}</SubtitleComponent></h3>
                            <img src={p1} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.kliman.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[krov1k, krov2k]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.kliman.subtitle1'))}</div>

                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.kliman.title')}</SubtitleComponent></h3>
                            <img src={krov1k} />
                        </div>
                    </div>
                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.hek.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[h4, h3, h1, h2]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.hek.subtitle1'))}</div>
                                        {/* <SubtitleComponent max>{t('references.hek.subtitle2')}</SubtitleComponent> */}
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.hek.title')}</SubtitleComponent></h3>
                            <img src={h4} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.krizanac.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[k1]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.krizanac.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.krizanac.title')}</SubtitleComponent></h3>
                            <img src={k1} />
                        </div>
                    </div>

                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.krnica.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[kr1, kr2]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.krnica.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.krnica.title')}</SubtitleComponent></h3>
                            <img src={kr1} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.krculi1.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[krc1]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.krculi1.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.krculi1.title')}</SubtitleComponent></h3>
                            <img src={krc1} />
                        </div>
                    </div>
                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.vrsar1.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[vrsar11, vrsar12]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.vrsar1.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.vrsar1.title')}</SubtitleComponent></h3>
                            <img src={vrsar11} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.peric.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[prc2, prc1]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.peric.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.peric.title')}</SubtitleComponent></h3>
                            <img src={prc2} />
                        </div>
                    </div>
                    <div className="twoItemsContainer">
                    <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.buletic1.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[blt1]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.buletic1.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.buletic1.title')}</SubtitleComponent></h3>
                            <img src={blt1} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.jelenic.title')}</SubtitleComponent></h3>
                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.jelenic.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.jelenic.title')}</SubtitleComponent></h3>
                            <img src={jel3} />
                        </div>
                    </div>
                    <div className="twoItemsContainer">
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.krculi2.title')}</SubtitleComponent></h3>
                                    <ImageSwiper images={[krc2]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.krculi2.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.krculi2.title')}</SubtitleComponent></h3>
                            <img src={krc2} />
                        </div>
                        <div className="referencePreview" onClick={() => {
                            setReferenceContent(
                                <div className="swiperContainer">
                                    <h3><SubtitleComponent medium white centered large>{t('references.vrsar2.title')}</SubtitleComponent></h3>

                                    <ImageSwiper images={[vrsar21, vrsar22]} thumbs={true} />

                                    <div className="projectDescription">
                                        <div>{generateParagraphs(t('references.vrsar2.subtitle1'))}</div>
                                    </div>
                                </div>); setOpenModal(true)
                        }} >
                            <h3><SubtitleComponent white semiBold centered medium>{t('references.vrsar2.title')}</SubtitleComponent></h3>
                            <img src={vrsar21} />
                        </div>
                    </div>
              




                </Trans>
            </ContainerComponent>
        </div>
    )
}

export default withTranslation()(References);
